import { makeAutoObservable } from "mobx";
import { apiObjUrl } from "src/common/apiUrl";
import { onError } from "src/common/onError";
import { rest } from "src/common/rest";
import { zIdNameNumber, ZIdNameNumber } from "src/types/ZIdName";

const store = makeAutoObservable({
  availableAttrsList: null as ZIdNameNumber[] | null,
  setAvailableAttrsList(list: ZIdNameNumber[]) {
    this.availableAttrsList = list;
  },
  loading: false,
  setLoading(flag: boolean) {
    this.loading = flag;
  },
  canMassEdit: false,
  setCanMassEdit(flag: boolean) {
    this.canMassEdit = flag;
  },

  async init(attrTypeVal: number, isAttrSystem: boolean) {
    if (isAttrSystem) {
      return;
    }
    try {
      this.setLoading(true);
      if (this.availableAttrsList === null) {
        const resp = await rest.get(
          apiObjUrl("/entities/available-replacement-value-types"),
        );
        this.setAvailableAttrsList(zIdNameNumber.array().parse(resp.data));
      }
      const isCurrAttrCanMassEdit = !!this.availableAttrsList?.find(
        (item) => item.id === attrTypeVal,
      );
      this.setCanMassEdit(isCurrAttrCanMassEdit);
    } catch (err) {
      onError(err);
    } finally {
      this.setLoading(false);
    }
  },
});

export type MassAttrEditSettingsStore = typeof store;

export const createMassAttrEditSettingsStore = (
  attrTypeVal: number,
  isAttrSystem: boolean,
): MassAttrEditSettingsStore => {
  store.init(attrTypeVal, isAttrSystem);
  return store;
};
